module.exports = __webpack_public_path__ + "static/media/auth0.95793651.svg";